import React from "react";
import styles from "./termsofservicepage.module.css";
import logo from "../../assets/logo.png";
import HeaderPage from "../../components/HeaderPage";
export default function TermsOfServicePage() {
  return (
    <div>
      <HeaderPage text="Terms of Service" />
      <div className={styles.container}>
        <main className={styles.main}>
          <section className={styles.section}>
            <h2>Introduction</h2>
            <p>
              Welcome to bHive! These Terms of Service ("Terms") govern your use
              of our online shopping platform and services. By accessing or
              using bHive, you agree to comply with and be bound by these Terms.
              If you do not agree to these Terms, please do not use our
              services.
            </p>
          </section>
          <section className={styles.section}>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By using the bHive website or any services provided by bHive, you
              agree to abide by these Terms, our Privacy Policy, and any other
              guidelines or rules applicable to our services.
            </p>
          </section>
          <section className={styles.section}>
            <h2>2. Account Registration</h2>
            <ul>
              <li>
                <strong>Eligibility:</strong> You must be at least 18 years old
                to use bHive. By registering, you represent and warrant that you
                meet this age requirement.
              </li>
              <li>
                <strong>Account Information:</strong> You must provide accurate
                and complete information when creating an account. You are
                responsible for maintaining the confidentiality of your account
                details and for all activities under your account.
              </li>
              <li>
                <strong>Account Security:</strong> Notify us immediately of any
                unauthorized use of your account. We are not liable for any loss
                or damage arising from your failure to protect your account
                information.
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2>3. Use of Services</h2>
            <ul>
              <li>
                <strong>Prohibited Activities:</strong> You agree not to engage
                in any activities that violate any laws, infringe on anyone's
                rights, or disrupt the functioning of our services.
              </li>
              <li>
                <strong>Content Ownership:</strong> You retain ownership of the
                content you post on bHive. However, by posting content, you
                grant us a license to use, display, and distribute your content
                on our platform.
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2>4. Purchases and Payments</h2>
            <ul>
              <li>
                <strong>Pricing:</strong> Prices for products on bHive are
                subject to change without notice. We reserve the right to modify
                or discontinue products at any time.
              </li>
              <li>
                <strong>Payment:</strong> All payments must be made through the
                payment methods available on bHive. You agree to provide
                accurate payment information and authorize us to charge your
                payment method for purchases made.
              </li>
              <li>
                <strong>Order Confirmation:</strong> Your receipt of an order
                confirmation does not signify our acceptance of your order. We
                reserve the right to accept or decline your order at any time.
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2>5. Shipping and Delivery</h2>
            <ul>
              <li>
                <strong>Shipping:</strong> We will make reasonable efforts to
                ensure timely delivery of products. However, delivery times are
                estimates and not guaranteed.
              </li>
              <li>
                <strong>Risk of Loss:</strong> The risk of loss for purchased
                items passes to you upon our delivery to the carrier.
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2>6. Returns and Refunds</h2>
            <ul>
              <li>
                <strong>Return Policy:</strong> Please refer to our Return
                Policy for information on returns and refunds.
              </li>
              <li>
                <strong>Refunds:</strong> Refunds will be issued to the original
                payment method used for the purchase.
              </li>
            </ul>
          </section>
          <section className={styles.section}>
            <h2>7. Privacy</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy
              to understand how we collect, use, and protect your information.
            </p>
          </section>
          <section className={styles.section}>
            <h2>8. Limitation of Liability</h2>
            <p>
              bHive and its affiliates will not be liable for any indirect,
              incidental, special, or consequential damages arising from your
              use of our services.
            </p>
          </section>
          <section className={styles.section}>
            <h2>9. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. The most current
              version of the Terms will be posted on our website. Your continued
              use of bHive after any changes constitutes your acceptance of the
              new Terms.
            </p>
          </section>
        </main>
        <footer className={styles.footer}>
          <p>
            If you have any questions about these Terms, please contact us at{" "}
            <a href="mailto:support@bhive.com">support@bhive.com</a>.
          </p>
        </footer>
      </div>
    </div>
  );
}
